import { Trans } from '@lingui/react'
import { number } from 'prop-types'
import { type FunctionComponent } from 'react'

import Price from 'views/components/atoms/Price'

type CostDetailProps = {
  totalAmount: number
  name: string
  amount: number
}

const CostDetail: FunctionComponent<CostDetailProps> = ({
  totalAmount,
  amount,
}): React.ReactElement => {
  return (
    <>
      <div className="l-flex l-flex--distribute-space a-h5 u-margin-x-small--ends u-margin--top">
        <div>
          <Trans id="general.label.subTotal" />
        </div>
        <div>
          <Price amount={totalAmount} symbolLeft />
        </div>
      </div>

      <div className="l-flex l-flex--distribute-space a-h4 u-no-margin--bottom">
        <div>
          <Trans id="general.label.discount" />
        </div>
        <div className="u-color--positive">
          <Price amount={-amount} symbolLeft decimalPlaces={2} />
        </div>
      </div>
    </>
  )
}

CostDetail.propTypes = {
  amount: number.isRequired,
  totalAmount: number.isRequired,
}

export default CostDetail
